<template>
  <ButtonSwitch
    class="form-control"
    v-model="value"
    :disabled="disabled"
    :name="schema.inputName"
    :id="getFieldID(schema)"
    :class="schema.fieldClasses"
    :options=items />
</template>

<script>
  import {abstractField} from "vue-form-generator";
  import protoselect from './protoselect'
  import ButtonSwitch from '@/helpers/components/interact/ButtonSwitch';
  
  export default {
    name: 'field-buttonselect',
    mixins: [abstractField, protoselect],
    components: {ButtonSwitch},
    computed: {
      items() {
				return this.schema.values;
      },
    },
  }
</script>

<style lang="scss">
  .form-group.field-buttonselect .field-wrap {
    margin-top: -10px;
    label:first-child {
      margin-left: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/helpers/mixins/form/ButtonSelect.vue